import {
    FETCH_OPTIONAL_FEATURE_FETCHING,
    FETCH_OPTIONAL_FEATURE_SUCCESS,
    FETCH_OPTIONAL_FEATURE_FAIL,
    UPDATE_OPTIONAL_FEATURE_UPDATING,
    UPDATE_OPTIONAL_FEATURE_SUCCESS,
    UPDATE_OPTIONAL_FEATURE_FAIL
} from 'actions/ActionTypes';

export const FeatureOptions = {
    OPT_IN: 'OPT_IN',
    OPT_OUT: 'OPT_OUT'
};

export const OptionalFeatures = {
    TAGGING: 'TAGGING',
    SEGMENT_LEADERBOARD: 'SEGMENT_LEADERBOARD'
};

const INITIAL_STATE = {
    optionalFeatures: {},
    optionalFeatureFetching: false,
    optionalFeatureFetchFail: false,
    optionalFeatureFetchFinished: false,
    optionalFeatureUpdating: false,
    optionalFeatureUpdateFail: false,
    optionalFeatureUpdateFinished: false
};

const optionalFeatureFetching = (state) => {
    return {
        ...state,
        optionalFeatureFetching: true,
        optionalFeatureFetchFail: false,
        optionalFeatureFetchFinished: false
    };
};

const optionalFeatureUpdating = (state) => {
    return {
        ...state,
        optionalFeatureUpdating: true,
        optionalFeatureUpdateFail: false,
        optionalFeatureUpdateFinished: false
    };
};

const optionalFeatureFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        optionalFeatures: isSuccess
            ? {
                  ...state.optionalFeatures,
                  [action.optionalFeature.optionalFeatureType]: action.optionalFeature
              }
            : state.optionalFeatures,
        optionalFeatureFetching: false,
        optionalFeatureFetchFail: !isSuccess,
        optionalFeatureFetchFinished: true
    };
};

const optionalFeatureUpdateFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        optionalFeatures: isSuccess
            ? {
                  ...state.optionalFeatures,
                  [action.optionalFeature.optionalFeatureType]: action.optionalFeature
              }
            : state.optionalFeatures,
        optionalFeatureUpdating: false,
        optionalFeatureUpdateFail: !isSuccess,
        optionalFeatureUpdateFinished: true
    };
};

export const isOptionalFeatureFetchFinished = (state) => {
    return state.optionalFeature.optionalFeatureFetchFinished;
};

export const isOptionalFeatureFetching = (state) => {
    return state.optionalFeature.optionalFeatureFetching;
};

export const isOptionalFeatureFetchFail = (state) => {
    return state.optionalFeature.optionalFeatureFetchFail;
};

export const isOptionalFeatureUpdateFinished = (state) => {
    return state.optionalFeature.optionalFeatureUpdateFinished;
};

export const isOptionalFeatureUpdating = (state) => {
    return state.optionalFeature.optionalFeatureUpdating;
};

export const isOptionalFeatureUpdateFail = (state) => {
    return state.optionalFeature.optionalFeatureUpdateFail;
};

export const getOptionalFeature = (state, featureType) => {
    return state.optionalFeature.optionalFeatures[featureType.toUpperCase()];
};

export const getOptionalFeatureOptionType = (state, featureType) => {
    return getOptionalFeature(state, featureType) && getOptionalFeature(state, featureType).userOptionType;
};

export const isOptionalFeatureOptedIn = (state, featureType) => {
    return (
        getOptionalFeature(state, featureType) &&
        getOptionalFeature(state, featureType).userOptionType === FeatureOptions.OPT_IN
    );
};

const handlers = {
    [FETCH_OPTIONAL_FEATURE_FETCHING]: optionalFeatureFetching,
    [FETCH_OPTIONAL_FEATURE_SUCCESS]: optionalFeatureFetchFinished(true),
    [FETCH_OPTIONAL_FEATURE_FAIL]: optionalFeatureFetchFinished(false),
    [UPDATE_OPTIONAL_FEATURE_UPDATING]: optionalFeatureUpdating,
    [UPDATE_OPTIONAL_FEATURE_SUCCESS]: optionalFeatureUpdateFinished(true),
    [UPDATE_OPTIONAL_FEATURE_FAIL]: optionalFeatureUpdateFinished(false)
};

export default function optionalFeature(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
